// extracted by mini-css-extract-plugin
module.exports = {"StoresReserveColorLogo":"StoresReserveColorLogo_StoresReserveColorLogo__1FYXk"};